export const CUSTOM_WIDGET_TYPES = [
  'payment_form',
  'office_search',
  'corporate_structure_office_list',
  'm1_search_form',
  'license_validation_form',
  'address_form'
];
